/**
 * Registry des coups de pouce — un fichier par attendu, calqué sur gen_<id>.js.
 *
 * Clé de résolution : le couple (attendu, generator_key). `generator_key` est
 * un champ PERSISTÉ (alimenté depuis _meta.generatorKey au POST, cf.
 * QCMDashboard.jsx) : il survit à l'aller-retour backend et arrive intact dans
 * l'espace élève. Rien à stocker côté back, rien à changer dans les générateurs.
 *
 * ⚠ Contrairement à ../index.js, ce fichier n'est PAS généré : ajouter l'import
 * à la main en créant un nouveau <id>.js.
 */

import cp609 from './609';
import cp610 from './610';
import cp611 from './611';
import cp612 from './612';
import cp613 from './613';
import cp614 from './614';
import cp615 from './615';
import cp616 from './616';
import cp617 from './617';
import cp618 from './618';
import cp619 from './619';
import cp620 from './620';
import cp621 from './621';
import cp622 from './622';
import cp623 from './623';
import cp624 from './624';
import cp625 from './625';
import cp626 from './626';
import cp627 from './627';
import cp637 from './637';
import cp638 from './638';
import cp639 from './639';
import cp640 from './640';
import cp641 from './641';
import cp642 from './642';
import cp643 from './643';
import cp644 from './644';
import cp646 from './646';
import cp647 from './647';
import cp648 from './648';
import cp649 from './649';
import cp650 from './650';
import cp651 from './651';
import cp652 from './652';
import cp653 from './653';
import cp654 from './654';
import cp655 from './655';
import cp656 from './656';
import cp657 from './657';
import cp658 from './658';
import cp659 from './659';
import cp660 from './660';
import cp661 from './661';
import cp662 from './662';
import cp663 from './663';
import cp664 from './664';
import cp665 from './665';
import cp666 from './666';
import cp667 from './667';
import cp668 from './668';
import cp669 from './669';
import cp670 from './670';
import cp671 from './671';
import cp672 from './672';
import cp673 from './673';
import cp674 from './674';
import cp675 from './675';
import cp676 from './676';
import cp677 from './677';
import cp678 from './678';
import cp679 from './679';
import cp680 from './680';
import cp681 from './681';
import cp682 from './682';
import cp683 from './683';
import cp684 from './684';
import cp685 from './685';
import cp686 from './686';
import cp687 from './687';
import cp688 from './688';
import cp689 from './689';
import cp690 from './690';
import cp899 from './899';
import cp900 from './900';
import cp901 from './901';
import cp902 from './902';
import cp903 from './903';
import cp951 from './951';
import cp1005 from './1005';
import cp1006 from './1006';
import cp1007 from './1007';
import cp1008 from './1008';
import cp1009 from './1009';
import cp1010 from './1010';
import cp1011 from './1011';
import cp1012 from './1012';
import cp1013 from './1013';
import cp1014 from './1014';
import cp1015 from './1015';
import cp1016 from './1016';
import cp1017 from './1017';
import cp1018 from './1018';
import cp1019 from './1019';
import cp1020 from './1020';
import cp1021 from './1021';
import cp1022 from './1022';
import cp1023 from './1023';
import cp1024 from './1024';
import cp1025 from './1025';
import cp1026 from './1026';
import cp1027 from './1027';
import cp1028 from './1028';
import cp1029 from './1029';
import cp1030 from './1030';
import cp1031 from './1031';
import cp1032 from './1032';
import cp1033 from './1033';
import cp1034 from './1034';
import cp1035 from './1035';
import cp1036 from './1036';
import cp1037 from './1037';
import cp1038 from './1038';
import cp1039 from './1039';
import cp1040 from './1040';
import cp1041 from './1041';
import cp1042 from './1042';
import cp1044 from './1044';
import cp1045 from './1045';
import cp1046 from './1046';
import cp1047 from './1047';
import cp1048 from './1048';
import cp1049 from './1049';
import cp1050 from './1050';
import cp1051 from './1051';
import cp1052 from './1052';
import cp1053 from './1053';
import cp1054 from './1054';
import cp1055 from './1055';
import cp1056 from './1056';
import cp1057 from './1057';
import cp1059 from './1059';
import cp1060 from './1060';
import cp1061 from './1061';
import cp1062 from './1062';
import cp1064 from './1064';
import cp1065 from './1065';
import cp1066 from './1066';
import cp1067 from './1067';
import cp1068 from './1068';
import cp1069 from './1069';
import cp1070 from './1070';
import cp1071 from './1071';
import cp1072 from './1072';
import cp1073 from './1073';
import cp1074 from './1074';
import cp1075 from './1075';
import cp1076 from './1076';
import cp1077 from './1077';
import cp1078 from './1078';
import cp1079 from './1079';
import cp1080 from './1080';
import cp1081 from './1081';
import cp1082 from './1082';
import cp1083 from './1083';
import cp1084 from './1084';
import cp1085 from './1085';
import cp1091 from './1091';
import cp1092 from './1092';
import cp1095 from './1095';
import cp1096 from './1096';
import cp1097 from './1097';
import cp1098 from './1098';
import cp1099 from './1099';
import cp1100 from './1100';
import cp1101 from './1101';
import cp1102 from './1102';
import cp1103 from './1103';
import cp1106 from './1106';
import cp1107 from './1107';
import cp1109 from './1109';
import cp1110 from './1110';
import cp1111 from './1111';
import cp1112 from './1112';
import cp1113 from './1113';
import cp1114 from './1114';
import cp1115 from './1115';
import cp1116 from './1116';
import cp1117 from './1117';
import cp1118 from './1118';
import cp1119 from './1119';
import cp1120 from './1120';
import cp1121 from './1121';
import cp1122 from './1122';
import cp1123 from './1123';
import cp1124 from './1124';
import cp1125 from './1125';
import cp1126 from './1126';
import cp1127 from './1127';
import cp1128 from './1128';
import cp1129 from './1129';
import cp1213, { CP_1214, CP_1215, CP_1216 } from './1213';
import cp1217 from './1217';
import cp1218, { CP_1219 } from './1218';
import cp1221 from './1221';
import cp1222 from './1222';
import cp1223 from './1223';
import cp1225, { CP_1226 } from './1225';
import cp1227 from './1227';
import cp1228 from './1228';
import cp1229 from './1229';
import cp1230, { CP_1231 } from './1230';
import cp1233 from './1233';
import cp1234, { CP_1235 } from './1234';
import cp1236, { CP_1237 } from './1236';
import cp1239, { CP_1240 } from './1239';
import cp1241 from './1241';
import cp1242, { CP_1243, CP_1244 } from './1242';
import cp1245 from './1245';
import cp1246, { CP_1247, CP_1248 } from './1246';
import cp1249, { CP_1250, CP_1251 } from './1249';
import cp1252 from './1252';
import cp1253, { CP_1254 } from './1253';

const COUPS_DE_POUCE = {
    609: cp609,
    610: cp610,
    611: cp611,
    612: cp612,
    613: cp613,
    614: cp614,
    615: cp615,
    616: cp616,
    617: cp617,
    618: cp618,
    619: cp619,
    620: cp620,
    621: cp621,
    622: cp622,
    623: cp623,
    624: cp624,
    625: cp625,
    626: cp626,
    627: cp627,
    637: cp637,
    638: cp638,
    639: cp639,
    640: cp640,
    641: cp641,
    642: cp642,
    643: cp643,
    644: cp644,
    646: cp646,
    647: cp647,
    648: cp648,
    649: cp649,
    650: cp650,
    651: cp651,
    652: cp652,
    653: cp653,
    654: cp654,
    655: cp655,
    656: cp656,
    657: cp657,
    658: cp658,
    659: cp659,
    660: cp660,
    661: cp661,
    662: cp662,
    663: cp663,
    664: cp664,
    665: cp665,
    666: cp666,
    667: cp667,
    668: cp668,
    669: cp669,
    670: cp670,
    671: cp671,
    672: cp672,
    673: cp673,
    674: cp674,
    675: cp675,
    676: cp676,
    677: cp677,
    678: cp678,
    679: cp679,
    680: cp680,
    681: cp681,
    682: cp682,
    683: cp683,
    684: cp684,
    685: cp685,
    686: cp686,
    687: cp687,
    688: cp688,
    689: cp689,
    690: cp690,
    899: cp899,
    900: cp900,
    901: cp901,
    902: cp902,
    903: cp903,
    951: cp951,
    1005: cp1005,
    1006: cp1006,
    1007: cp1007,
    1008: cp1008,
    1009: cp1009,
    1010: cp1010,
    1011: cp1011,
    1012: cp1012,
    1013: cp1013,
    1014: cp1014,
    1015: cp1015,
    1016: cp1016,
    1017: cp1017,
    1018: cp1018,
    1019: cp1019,
    1020: cp1020,
    1021: cp1021,
    1022: cp1022,
    1023: cp1023,
    1024: cp1024,
    1025: cp1025,
    1026: cp1026,
    1027: cp1027,
    1028: cp1028,
    1029: cp1029,
    1030: cp1030,
    1031: cp1031,
    1032: cp1032,
    1033: cp1033,
    1034: cp1034,
    1035: cp1035,
    1036: cp1036,
    1037: cp1037,
    1038: cp1038,
    1039: cp1039,
    1040: cp1040,
    1041: cp1041,
    1042: cp1042,
    // 1043 (5e, ×÷ 10/100/1000) : wrapper des gens 6e 1008 + 1009 : mêmes
    // generator_keys (produits_* / quotients_*), mêmes fiches.
    1043: { ...cp1008, ...cp1009 },
    1044: cp1044,
    1045: cp1045,
    1046: cp1046,
    1047: cp1047,
    // 1048 : la carte 1 est gen_1012 re-badgé, ses aides sont reprises dans cp1048.
    1048: cp1048,
    1049: cp1049,
    1050: cp1050,
    1051: cp1051,
    1052: cp1052,
    1053: cp1053,
    1054: cp1054,
    1055: cp1055,
    1056: cp1056,
    1057: cp1057,
    // 1058 (5e, entretenir les tables, rubrique Puissances) : wrapper de gen_1047,
    // mêmes generator_keys, mêmes fiches.
    1058: cp1047,
    1059: cp1059,
    1060: cp1060,
    1061: cp1061,
    1062: cp1062,
    // 1063 (5e, nombre quotient, rubrique Calcul littéral) : wrapper de gen_1049,
    // mêmes generator_keys, même fiche « 4 parts égales qui font 13 ».
    1063: cp1049,
    // 4e, Opérations sur les nombres relatifs (2026-09-12). 1093 (entretien
    // des tables) : wrapper de gen_1047 ; 1094 (×÷ 10/100/1000) : wrapper de
    // gen_1043, donc des gens 6e 1008 + 1009. Mêmes generator_keys, mêmes fiches.
    1093: cp1047,
    1094: { ...cp1008, ...cp1009 },
    // 1102 (4e, Puissances, x/ 10 100 1000 et 1 200 = 1,2 x ...) : les cartes de 1043
    // gardent leurs fiches (gens 6e 1008 + 1009) ; la carte neuve manque_* a la sienne (le tableau des rangs).
    1102: { ...cp1008, ...cp1009, ...cp1102 },
    1091: cp1091,
    1092: cp1092,
    1095: cp1095,
    1096: cp1096,
    1097: cp1097,
    1098: cp1098,
    1099: cp1099,
    1100: cp1100,
    1101: cp1101,
    // 1105 (4e, Racine carrée, donner les carrés de 0 à 12) : les clés donner_*
    // de gen_1101, la même grille 13 x 13.
    1105: cp1101,
    // 3e (2026-09-12). 1220 (donner les carrés de 0 à 12) : wrapper de 1105, la même grille.
    1220: cp1101,
    // 3e, seconde passe coups de pouce (2026-09-13), lot 1 Nombres / Divisibilité.
    // 1213-1216 (fractions, un fichier gen_1213) : ± = les quatre pages de 1097,
    // × et ÷ une page chacune.
    1213: cp1213,
    1214: CP_1214,
    1215: CP_1215,
    1216: CP_1216,
    1217: cp1217,
    // 1218/1219 (puissances, un fichier gen_1218) : une page par attendu.
    1218: cp1218,
    1219: CP_1219,
    1221: cp1221,
    1222: cp1222,
    // 1223 (dénominateur commun) : trois pages de 1097, la réponse est le nombre.
    1223: cp1223,
    // 1224 (critères de divisibilité) : pas de fiche, pur rappel des quatre
    // critères (règle 9 : toute aide utile donne la réponse).
    // Lot 2 Calcul littéral (13/09).
    // 1225/1226 (équations, un fichier gen_1225) : une page par attendu.
    1225: cp1225,
    1226: CP_1226,
    1227: cp1227,
    1228: cp1228,
    1229: cp1229,
    // 1230/1231 (développer / factoriser, un fichier gen_1230) : le même exemple dans les deux sens.
    1230: cp1230,
    1231: CP_1231,
    // 1232 (pair 2n, impair 2n + 1) : pas de fiche, pur rappel (règle 9).
    1233: cp1233,
    // Lot 3 Repérage / Espace (13/09).
    // 1234/1235 (droite graduée, relatifs) : le même dessin, placer puis lire.
    1234: cp1234,
    1235: CP_1235,
    // 1236/1237 (repère, un fichier gen_1236) : la même page dans les deux sens.
    1236: cp1236,
    1237: CP_1237,
    // 1238 (reconnaître des solides) : pas de fiche, pur rappel (règle 9).
    1239: cp1239,
    1240: CP_1240,
    1241: cp1241,
    // Lot 4 Triangles / Transformations / Statistiques (13/09).
    // 1242, 1243, 1244 : le même triangle ABC rectangle en A, une page par attendu.
    1242: cp1242,
    1243: CP_1243,
    1244: CP_1244,
    // 1245 : les cartes déléguées gardent la fiche de leur gen source (1070, 951), deux pages neuves.
    1245: cp1245,
    // 1246/1247/1248 (un fichier gen_1246) : trois pages « un cas par page », la même série.
    1246: cp1246,
    1247: CP_1247,
    1248: CP_1248,
    // Lot 5 Proportionnalité (13/09).
    // 1249/1250/1251 (partages, un fichier gen_1249) : la barre en parts, une page par attendu.
    1249: cp1249,
    1250: CP_1250,
    1251: CP_1251,
    1252: cp1252,
    1253: cp1253,
    1254: CP_1254,
    1103: cp1103,
    // 1104 (4e, Puissances, 10 au carre et 10 au cube) : les clés dix_* de gen_1103, le même cube.
    1104: cp1103,
    1106: cp1106,
    1107: cp1107,
    // 1108 (4e, Calcul littéral, 3x c est 3 fois x) : pas de fiche, pur rappel de
    // l écriture (règle 9) ; le sens vit dans 1109, la valeur dans 1111.
    1109: cp1109,
    1110: cp1110,
    1111: cp1111,
    1064: cp1064,
    1065: cp1065,
    1066: cp1066,
    1067: cp1067,
    1068: cp1068,
    1069: cp1069,
    1070: cp1070,
    1071: cp1071,
    1072: cp1072,
    1073: cp1073,
    1074: cp1074,
    1075: cp1075,
    1076: cp1076,
    1077: cp1077,
    1078: cp1078,
    1079: cp1079,
    1080: cp1080,
    1081: cp1081,
    1082: cp1082,
    1083: cp1083,
    1084: cp1084,
    1085: cp1085,
    1112: cp1112,
    1113: cp1113,
    1114: cp1114,
    1115: cp1115,
    1116: cp1116,
    1117: cp1117,
    1118: cp1118,
    1119: cp1119,
    1120: cp1120,
    1121: cp1121,
    1122: cp1122,
    1123: cp1123,
    1124: cp1124,
    1125: cp1125,
    1126: cp1126,
    1127: cp1127,
    1128: cp1128,
    1129: cp1129,
};

export default COUPS_DE_POUCE;
